module.exports = __webpack_public_path__ + "static/Blister-72c7d5111f9fba1e8a39de20f222c1ca.jpg";